// extracted by mini-css-extract-plugin
export var dropdown = "_u4-0";
export var imageWrapper = "_u4-3";
export var itemNameContainer = "_u4-1";
export var productImage = "_u4-2";
export var spinnerWrapper = "_u4-4";